import { useEffect, useState } from 'react';

import { toPoliticalMatchCandidateMatches } from '@/adapters/political-match-adapter';
import type { PoliticalMatchCandidateMatch } from '@/models/political-match';
import { getPoliticalMatches } from '@/services/political-match-service';
import { useBrowserQueryCache } from '@/lib/query-cache/use-browser-query-cache';

type PoliticalMatchMatchesState = {
  status: 'loading' | 'success' | 'error';
  matches: PoliticalMatchCandidateMatch[];
  error?: string;
};

export function usePoliticalMatchMatches(): PoliticalMatchMatchesState {
  const queryCache = useBrowserQueryCache();
  const [state, setState] = useState<PoliticalMatchMatchesState>({
    status: 'loading',
    matches: [],
  });

  useEffect(() => {
    let active = true;

    getPoliticalMatches({ cache: queryCache })
      .then((response) => {
        if (!active) {
          return;
        }

        setState({
          status: 'success',
          matches: toPoliticalMatchCandidateMatches(response),
        });
      })
      .catch(() => {
        if (!active) {
          return;
        }

        setState({
          status: 'error',
          matches: [],
          error: 'Não foi possível carregar os candidatos do Match Político agora.',
        });
      });

    return () => {
      active = false;
    };
  }, [queryCache]);

  return state;
}
